export const testimonials = [
  {
    name: "林之南",
    role: "内容创作者",
    initial: "林",
    content:
      "以前找选题要在好几个平台刷半天，现在打开首页看热榜就够了，排名和热度条一目了然，省下来的时间都拿去找素材了。",
  },
  {
    name: "陈小满",
    role: "普通吃瓜群众",
    initial: "陈",
    content:
      "最喜欢围观现场那栏，能看到别人在聊什么、聊到哪一步了，比单纯看标题有意思多了，也不容易被带节奏。",
  },
  {
    name: "周与野",
    role: "媒体编辑",
    initial: "周",
    content:
      "内容整合得比较克制，会标出争议点而不是下结论，这点很难得。我们组现在把它当作每日热点的第一站。",
  },
  {
    name: "苏慢",
    role: "生活方式博主",
    initial: "苏",
    content:
      "分类做得很清楚，生活类和潮流类的话题不会和娱乐混在一起。翻到自己关心的板块，效率高很多。",
  },
];